import React, { useState } from 'react';
import styled, { css } from 'styled-components';
import { Box } from '../Box';
import { Icon } from '../Icon';
import { Text } from '../Text';
import { List } from './List';
import { theme } from '../theme';
export const ActionDropdown = ({ id, className = '', label, value, list, onSelect, ...marginProps }) => {
    const [open, setOpen] = useState(false);
    return (React.createElement(Container, { id: id, className: className, onClick: () => setOpen((currentOpen) => !currentOpen), ...marginProps },
        label && (React.createElement(Text, { tag: "label", color: "sesame", typo: "label" }, label)),
        React.createElement(Label, { "$text": value.textColor ?? 'liquorice', "$bg": value.bgColor ?? 'sesame' },
            React.createElement(SelectedOption, null, value.label),
            React.createElement(Icon, { render: "caret", color: value.textColor ?? 'sesame', size: 24, rotate: open ? 180 : 0 })),
        React.createElement(OuterContainer, { open: open },
            React.createElement(List, { options: list, selectOption: onSelect }))));
};
const Label = styled.div(({ $text, $bg }) => css `
    color: ${theme.colors[$text]};
    background-color: ${theme.colors[$bg]};
    position: relative;
    width: 100%;
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    text-align: center;
    border-radius: 100px;
    padding: 16px 16px 14px;
    box-sizing: border-box;
    user-select: none;
  `);
const SelectedOption = styled.span `
  font-size: 14px;
  font-weight: bold;
  white-space: nowrap;
  text-overflow: ellipsis;
`;
const Container = styled(Box) `
  position: relative;
  display: block;
  width: 210px;
  height: 48px;
  text-align: center;
  cursor: pointer;
  outline: none;
  border-radius: 8px;
`;
const OuterContainer = styled.div(({ open }) => css `
    position: absolute;
    width: 100%;
    border-radius: 12px;
    margin-top: 8px;
    display: ${open ? 'block' : 'none'};
    max-height: ${open ? '235px' : '48px'};
    background-color: ${theme.colors.custard};
    overflow-y: ${open ? 'auto' : 'hidden'};
    z-index: 4;
    transition: all 0.2s ease-in-out;
  `);
//# sourceMappingURL=ActionDropdown.js.map